// removed by extract-text-webpack-plugin
module.exports = {"activity":"activity__3P7K0","type":"type__3ZM0u","icon":"icon__1Ep5D","typeBold":"typeBold__vIlSQ","count":"count__30owx","countRed":"countRed__3vxyG","contact":"contact__zs0xP","profession":"profession__1aKgn","date":"date__3-zRj","avatar":"avatar__2wHXS","call":"call__3LRvR","info":"info__2e8TY","relatedActivities":"relatedActivities__3aU3-","expanded":"expanded__2htpp","container":"container__1QZRz","relatedTitle":"relatedTitle__3X9cR","related":"related__2G23S","relatedDate":"relatedDate__mLnxt"};


//////////////////
// WEBPACK FOOTER
// ./components/profile/activity/style.scss
// module id = Fg8D
// module chunks = 27